import { render, staticRenderFns } from "./car_base2.vue?vue&type=template&id=403e674f&scoped=true"
import script from "./car_base2.vue?vue&type=script&lang=js"
export * from "./car_base2.vue?vue&type=script&lang=js"
import style0 from "./car_base2.vue?vue&type=style&index=0&id=403e674f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403e674f",
  null
  
)

export default component.exports